<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { formatPrice } from "#/utils/i18next";

interface ReceiptItem {
	name: string;
	amount: number;
	price: number;
}

interface Props {
	title?: string | null;
	items?: ReceiptItem[];
	discount?: number;
	total?: number | null;
	currencySymbol?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
	title: null,
	items: () => [],
	discount: 0,
	total: null,
	currencySymbol: null,
});

const { t } = useTranslation();
</script>

<template>
	<div class="kso_printer">
		<div class="kso_printer_bar"><span class="kso_printer_bar_slot" /></div>
		<div class="kso_printer_paper_window">
			<i class="kso_printer_gust kso_printer_gust_1" />
			<i class="kso_printer_gust kso_printer_gust_2" />
			<i class="kso_printer_gust kso_printer_gust_3" />
			<div class="kso_printer_paper">
				<p class="kso_receipt_name">{{ props.title || t(`kso.print.receipt.title`) }}</p>
				<span class="kso_receipt_divider" />
				<p v-for="(item, index) in props.items" :key="index" class="kso_receipt_row">
					<span class="kso_receipt_item">{{ item.name }} × {{ item.amount }}</span>
					<span>{{ formatPrice(item.price, props.currencySymbol) }}</span>
				</p>
				<span v-if="props.items.length" class="kso_receipt_divider" />
				<p v-if="props.discount !== 0" class="kso_receipt_row">
					<span>{{ t(`kso.print.receipt.discount`) }}</span>
					<span>{{ formatPrice(props.discount, props.currencySymbol) }}</span>
				</p>
				<p v-if="props.total !== null" class="kso_receipt_row kso_receipt_row_total">
					<span>{{ t(`kso.print.receipt.total`) }}</span>
					<span>{{ formatPrice(props.total, props.currencySymbol) }}</span>
				</p>
				<p class="kso_receipt_thanks">{{ t(`kso.print.receipt.thanks`) }}</p>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
  @use './ksoPrinter.scss';
</style>
